import pregnancyQuizIcon from "../../assets/pregnancy-quiz-icon.svg";

export default function PregnancyQuizLauncher() {
  return (
    <div className="relative">
      <a
        href="https://v0-pregnancy-quiz-app-ruby.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex flex-col items-center group"
        aria-label="태아 성별 예측"
      >
        <div
          className="
      mb-2
      rounded-full
      bg-white
      px-2 py-1
      text-sm
      font-extrabold
      text-[#a8c5a7]
      shadow
    "
        >
          태아 성별 예측
        </div>

        <div
          className="
            relative
        h-16 w-16
        sm:h-18 sm:w-18
        md:h-20 md:w-20
            rounded-full
            bg-white
            shadow-xl
            flex items-center justify-center
            transition
            duration-300
            group-hover:scale-105
          "
          style={{
            background:
              "linear-gradient(white, white) padding-box, linear-gradient(to bottom, #f5b896, #a8c5a7) border-box",
            border: "4px solid transparent",
          }}
        >
          <img
            src={pregnancyQuizIcon}
            alt="태아 성별 예측"
            className="h-[100%] w-[100%] object-contain select-none"
            draggable={false}
          />

          <span
            className="absolute -top-1 -right-1 h-3 w-3 rounded-full animate-ping"
            style={{ backgroundColor: "#f5b896" }}
          />
          <span
            className="absolute -top-1 -right-1 h-3 w-3 rounded-full"
            style={{ backgroundColor: "#f5b896" }}
          />
        </div>
      </a>
    </div>
  );
}
